import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import installElementPlus from './plugins/element';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import print from 'vue3-print-nb';
import './styles/element/index.scss';

// 公共样式
import './assets/css/item.css';
import './assets/css/togyUI.css';
import '/node_modules/swiper/swiper.scss';

// 全局挂载请求
import api from './api/api';
import CommonApi from './api/CommonApi';
import websocket from './api/websocket';

import PublicView from './components/Components';

const app = createApp(App);
installElementPlus(app);
app.config.globalProperties.$api = api;
app.config.globalProperties.$CommonApi = CommonApi;
app.config.globalProperties.$websocket = websocket.webSocket;
app.use(store).use(router).use(print).use(VueAwesomeSwiper).use(PublicView).mount('#app')